import { RefObject } from "react";
import { Footer } from "../MainPage/Footer";
import { Header } from "../MainPage/Header";

interface LayoutProps {
   imageRef?: RefObject<HTMLDivElement>;
   page?: string;
   children: React.ReactNode;
}

export const Layout = ({ page, children }: LayoutProps) => {
   return (
      <div>
         {page && page !== "configurator" && <Header page={page} />}
         {children}
         {page !== "configurator" && <Footer />}
      </div>
   );
};
